import { render, staticRenderFns } from "./AdminSuerveyTable.vue?vue&type=template&id=2a4fdc1c&scoped=true"
import script from "./AdminSuerveyTable.vue?vue&type=script&lang=js"
export * from "./AdminSuerveyTable.vue?vue&type=script&lang=js"
import style0 from "./AdminSuerveyTable.vue?vue&type=style&index=0&id=2a4fdc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4fdc1c",
  null
  
)

export default component.exports